import { twMerge } from "tailwind-merge";
import { inputStyles } from "../../input";
import { DisplayControlProps } from "../types";

export default function DisplayControl(props: Readonly<DisplayControlProps>) {
  const { value, className, children, ...rest } = props;
  return (
    <div className={twMerge(inputStyles(rest), className)}>{children}</div>
  );
}
